import { observer } from "mobx-react-lite";
import './BubbleBar.scss';

const BubbleBar = observer(({ children, className, style }) => {


    return (
        <div className={`BubbleBar ${className}`} style={style}>
            {children}
        </div>
    );
});

export default BubbleBar;